
const checkAccess = (object, action) => {
    const raw = localStorage.getItem("permissions");
    if (!raw) return false;
  
    const permissions = JSON.parse(raw);
    return permissions.some((perm) => perm.object === object && perm.action === action);
};

export default checkAccess;

